import type { CodeLabels, ReviewStatus } from "@/types/species-profile";

export const MONTHS = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];

export const label = (labels: CodeLabels | undefined, code: string | null | undefined): string =>
  code ? labels?.[code] ?? code : "—";

export const fmtDate = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString("pt-BR") : "";

export const fmtNumber = (v: number | null | undefined, unit: string) =>
  v === null || v === undefined ? null : `${v.toLocaleString("pt-BR")} ${unit}`;

export function fmtRange(min: number | null, max: number | null, unit: string): string {
  if (min !== null && max !== null) return `${min.toLocaleString("pt-BR")}–${max.toLocaleString("pt-BR")} ${unit}`;
  return fmtNumber(min ?? max, unit) ?? "—";
}

export const fmtBool = (v: boolean | null | undefined, yes = "Sim", no = "Não") =>
  v === null || v === undefined ? "—" : v ? yes : no;

export const REVIEW_TONE: Record<ReviewStatus, string> = {
  RASCUNHO_IA: "bg-warning-50 text-warning-800 border-warning-200",
  EM_REVISAO: "bg-accent-50 text-accent-800 border-accent-200",
  REVISADO: "bg-primary-50 text-primary-800 border-primary-200",
};

export const REVIEW_ICON: Record<ReviewStatus, string> = {
  RASCUNHO_IA: "ri-robot-2-line",
  EM_REVISAO: "ri-time-line",
  REVISADO: "ri-shield-check-line",
};

export const FIT_TONE: Record<string, string> = {
  RECOMENDADA: "bg-primary-50 text-primary-700",
  COM_RESTRICOES: "bg-warning-50 text-warning-700",
  NAO_RECOMENDADA: "bg-danger-50 text-danger-700",
};

export const LEVEL_TONE: Record<string, string> = {
  BAIXA: "text-primary-700",
  MEDIA: "text-warning-700",
  ALTA: "text-danger-700",
};

export const FIELD_LABELS: Record<string, string> = {
  description: "Descrição", synonyms: "Sinônimos", other_popular_names: "Outros nomes populares",
  life_form: "Forma de vida", native_biomes: "Biomas", natural_distribution: "Distribuição natural",
  adult_height_min_m: "Altura adulta mínima", adult_height_max_m: "Altura adulta máxima",
  crown_diameter_max_m: "Diâmetro máximo da copa", growth_rate: "Crescimento", longevity: "Longevidade",
  foliage: "Folhagem", flowering_months: "Floração", fruiting_months: "Frutificação",
  flower_color: "Cor da flor", fruit_type: "Tipo de fruto", edible_fruit: "Fruto comestível",
  pollination_dispersal: "Polinização e dispersão", root_system: "Sistema radicular",
  root_aggressiveness: "Agressividade da raiz", wood_strength: "Resistência da madeira",
  branch_drop_tendency: "Tendência à queda de galhos", fit_narrow_sidewalk: "Calçada estreita",
  fit_wide_sidewalk: "Calçada larga", fit_under_power_lines: "Sob fiação", fit_median_strip: "Canteiro central",
  fit_parks_squares: "Praças e parques", min_permeable_area_m2: "Área permeável mínima",
  min_distance_building_m: "Distância mínima de edificação", urban_fit_notes: "Observações de uso urbano",
  benefit_codes: "Benefícios", benefits: "Benefícios (detalhe)", problem_codes: "Problemas",
  problems: "Problemas (detalhe)", toxicity: "Toxicidade", planting: "Plantio", pruning: "Poda",
  pruning_season: "Época de poda", pruning_tolerance: "Tolerância à poda", irrigation: "Irrigação",
  fertilization: "Adubação", transplant_tolerance: "Tolerância ao transplante",
  seedling_production: "Produção de mudas", management_notes: "Observações de manejo",
  conservation_status: "Grau de ameaça", legal_protection: "Proteção legal",
  cutting_restricted: "Corte restrito", review_status: "Situação da ficha", note: "Motivo",
  common_name: "Nome", agent_scientific_name: "Agente", agent_type: "Tipo de agente",
  affected_parts: "Partes afetadas", symptoms: "Sintomas", severity: "Severidade", management: "Manejo",
};
